/* Validate only reorder forms, including forms inserted by the theme editor. */
(() => {
  if (window.fvbReorderValidationInstalled) return;
  window.fvbReorderValidationInstalled = true;

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-fvb-invoice]')) {
      event.target.setCustomValidity('');
    }
  });

  // Capture runs before Dawn's AJAX submit handler creates FormData.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[data-fvb-reorder]')) return;
    const invoice = form.querySelector('[data-fvb-invoice]');
    if (!invoice) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    invoice.value = invoice.value.trim();
    invoice.setCustomValidity(invoice.value ? '' : 'Bitte geben Sie die Rechnungsnummer Ihrer Erstbestellung ein.');
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);
})();
